import { TextInput } from '@ordr-as/umami-react/form';
import InvoiceField from '../../../../../components/InvoiceField';
import type {
  CustomerRegisteryEnabledDto,
  OrdrServiceSearchResponseDto,
  PaymentMethodDto,
  UnintegratedPaymentFields,
} from '../../../../../../generated-api';
import type { DebouncedState } from 'use-debounce';
import { useScreenSize } from '../../../../../context/ScreenSizeContext';

interface Props {
  paymentMethod: PaymentMethodDto;
  autoFocus: boolean | undefined;
  dynamicFields: UnintegratedPaymentFields[] | undefined;
  dynamicFieldValues: Record<string, string>;
  setDynamicFieldValues: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  setSearchText: DebouncedState<(value: string | undefined) => void>;
  customerRegistryEnabledDto: CustomerRegisteryEnabledDto | undefined;
  customerRegistry: OrdrServiceSearchResponseDto | undefined;
}

const CheckoutUnintegratedPaymentFields = (props: Props) => {
  const {
    paymentMethod,
    autoFocus,
    dynamicFields,
    dynamicFieldValues,
    setDynamicFieldValues,
    setSearchText,
    customerRegistryEnabledDto,
    customerRegistry,
  } = props;
  const { isPhone } = useScreenSize();

  if (paymentMethod.provider === 'UNINTEGRATED' && paymentMethod.paymentMethod === 'INVOICE') {
    return (
      dynamicFields?.map((dynamicField) => (
        <InvoiceField
          key={dynamicField.displayLabel}
          unintegratedField={dynamicField}
          dyamicFieldValues={dynamicFieldValues}
          setDynamicFieldValues={setDynamicFieldValues}
          customerRegistryEnabledDto={customerRegistryEnabledDto}
          customerRegistry={customerRegistry}
          setSearchText={setSearchText}
        />
      )) ?? null
    );
  }

  return (
    dynamicFields?.map((dynamicField) => (
      <TextInput
        label={dynamicField.displayLabel}
        className="mb-4"
        autoFocus={autoFocus}
        fullWidth={isPhone}
        required={dynamicField.required}
        key={dynamicField.displayLabel}
        value={dynamicFieldValues[dynamicField.name]}
        onChange={(e) => {
          setDynamicFieldValues({ ...dynamicFieldValues, [dynamicField.name]: e.trimStart() });
        }}
      />
    )) ?? null
  );
};

export default CheckoutUnintegratedPaymentFields;
